var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppModal",
    {
      attrs: {
        id: "manage-membership-modal",
        action: _vm.membership.buttonText,
        actionColor: "danger",
        secondaryActionColor: "black",
        title: "Are you sure?",
        loading: _vm.loading,
        "secondary-action": "Cancel",
        hideClose: ""
      },
      on: { cta: _vm.updateSubscription, "secondary-cta": _vm.closeModal }
    },
    [
      _c("div", { staticClass: "d-flex my-2" }, [
        _c("div", { staticClass: "col-12" }, [
          _c("p", { staticClass: "sub-text text-center" }, [
            _vm._v(
              "\n\t\t\t\t" +
                _vm._s(
                  `Just confirming that you want to ${_vm.membership.action} ${_vm.fanName}'s subscription to `
                ) +
                "\n\t\t\t\t"
            ),
            _c("span", { staticClass: "bold-text" }, [
              _vm._v(_vm._s(_vm.membership.productTitle))
            ]),
            _vm._v(". This action cannot be undone.\n\t\t\t")
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }